import { getStudioUrl } from '@cartwhl/common/utils/getStudioUrl';
import LazyVideo from '@cartwhl/ui/atoms/LazyVideo';

import { CDN } from 'consts';

import { ProductPageLayout } from './ProductPageLayout';

export default function CharacterGenerationPage() {
  return (
    <ProductPageLayout.Root>
      <ProductPageLayout.Hero
        title="Character Generator"
        description="AI Character Creation & Rigging"
        ctas={[{ text: 'Try in Canvas', href: getStudioUrl() }]}
      />

      {/* Hero Section */}
      <ProductPageLayout.MediaContent>
        <ProductPageLayout.MediaContentMedia>
          <LazyVideo
            src={`${CDN}v2_product_character_gen_hero.webm`}
            className="h-full w-full rounded-[inherit]"
            mode="autoplay"
          />
        </ProductPageLayout.MediaContentMedia>
        <ProductPageLayout.MediaContentBody
          headline="Character Generator is our tool for creating fully rigged 3D characters from a text description or reference image."
          description={
            <>
              Describe the character you need—or provide visual reference—and
              Character Generator produces a clean, 3D model with a compatible
              rig, ready for posing, animation, and motion application. Designed
              for speed without sacrificing structure, it enables teams to move
              from concept to usable character assets in minutes.
              <br />
              <br />
              Use Character Generator in Cartwheel Canvas for hands-on creation,
              or integrate it via API for production workflows.
            </>
          }
        />
      </ProductPageLayout.MediaContent>

      {/* Feature Grid */}
      <ProductPageLayout.FeatureGrid>
        <ProductPageLayout.FeatureGridItem
          title="Text- or reference-driven creation"
          description="Generate characters from natural language descriptions or reference imagery. Define style, proportions, and visual intent, and Character Generator produces a coherent 3D character aligned with your input."
        >
          <LazyVideo
            src={`${CDN}v2_product_character_gen_02.text_or_ref_driven.webm`}
            className="h-full w-full rounded-[inherit]"
            mode="autoplay"
          />
        </ProductPageLayout.FeatureGridItem>
        <ProductPageLayout.FeatureGridItem
          title="Production-ready rigging"
          description="Every character is delivered with a clean, animation-ready rig. Characters are compatible with downstream posing, motion generation, and editing workflows—no manual setup required."
        >
          <LazyVideo
            src={`${CDN}v2_product_character_gen_03_production_ready_rigging.webm`}
            className="h-full w-full rounded-[inherit]"
            mode="autoplay"
          />
        </ProductPageLayout.FeatureGridItem>
      </ProductPageLayout.FeatureGrid>

      {/* Showcase Section */}
      <ProductPageLayout.Showcase
        title="Designed for motion workflows"
        description="Characters generated with Character Generator are built to work seamlessly with Swing, Motion Editor, and Comic. Apply generated or captured motion directly, without re-rigging or retargeting overhead."
      >
        <LazyVideo
          src={`${CDN}v2_product_character_gen_04.designed_for_motion_workflows.webm`}
          className="h-full w-full rounded-[inherit]"
          mode="autoplay"
        />
      </ProductPageLayout.Showcase>
    </ProductPageLayout.Root>
  );
}
